export const translations = {
  en: {
    nav: {
      home: "Home",
      features: "Features",
      gallery: "Gallery",
      amenities: "Amenities",
      contact: "Contact",
      schedule: "Schedule a Tour"
    },
    hero: {
      badge: "For Rent",
      title: "Beautiful Two-Story Townhouse",
      price: "$2,800 per month",
      internet: "Internet included",
      parking: "Two private parking spaces",
      pool: "Community pool",
      tour: "Schedule a Tour",
      call: "Call",
      text: "Text",
      directions: "Get Directions",
      directionsAria: "Get directions to 7429 NW 182nd St, Hialeah, Florida",
      address: "7429 NW 182nd St, Hialeah, FL 33015",
      available: "Available Now",
      bedBath: "2 Bedrooms • 2.5 Bathrooms",
      internetInc: "Internet Included",
      parkingInc: "Two Assigned Parking Spaces",
      poolInc: "Community Pool",
      laundryInc: "In-Unit Washer and Dryer",
      checkAvail: "Check Availability",
      callNow: "Call Now",
      sendText: "Send a Text"
    },
    quickFacts: {
      bed: "2 Bedrooms",
      bath: "2.5 Bathrooms",
      laundry: "In-Unit Washer & Dryer",
      rent: "$2,800 Monthly Rent",
      internet: "Internet Included",
      parking: "2 Assigned Parking Spaces",
      pool: "Community Pool",
      security: "Overnight Security"
    },
    exterior: {
      label: "WELCOME HOME",
      title: "Welcoming Townhouse Exterior with Two Private Parking Spaces",
      desc: "Arrive home to a bright two-story townhouse framed by palm trees and a welcoming covered entrance. Two private assigned parking spaces are conveniently located directly in front of the property, providing easy everyday access. The Mediterranean-inspired exterior, tiled roofline, and attractive community setting create a warm first impression.",
      badges: [
        "Two Private Assigned Parking Spaces",
        "Parking Directly in Front",
        "Covered Entrance",
        "Two-Story Townhouse"
      ],
      btn: "Schedule a Private Tour"
    },
    intro: {
      title: "A Comfortable Home With Space, Privacy, and Convenience",
      p1: "The townhouse offers an updated kitchen, comfortable living areas, in-unit laundry, a private covered patio, and two assigned parking spaces.",
      p2: "Internet is included in the monthly rent, helping make everyday living simpler.",
      btn: "Schedule Your Private Tour"
    },
    features: {
      title: "Property Features",
      subtitle: "Thoughtfully designed spaces for comfortable living.",
      f1: {
        title: "Bright and Welcoming Living Area",
        desc: "The main living area features light flooring, crown molding, a distinctive stone accent wall with built-in lighting, and a comfortable open layout."
      },
      f2: {
        title: "Updated Kitchen",
        desc: "The kitchen features white shaker-style cabinets, stainless-steel appliances, modern countertops, a large peninsula, and an open connection to the main living area."
      },
      f3: {
        title: "In-Unit Laundry",
        desc: "Premium full-size appliances for your convenience."
      },
      f4: {
        title: "Your Own Private Outdoor Retreat",
        desc: "Enjoy a spacious covered and fenced patio with room for outdoor seating, dining, relaxing, or entertaining. There are no neighbors directly behind the townhouse. Beyond the community are greenery, mature trees, a railroad, and a lake.",
        sinkHeading: "Convenient Outdoor Sink and Prep Area",
        sinkDesc: "The covered private patio includes a built-in sink and counter, providing a convenient space for outdoor meal preparation, cleanup, and entertaining."
      },
      f5: {
        title: "Bedrooms",
        p1: "A bright primary bedroom with a high ceiling, natural light, tiled flooring, and flexible space.",
        p2: "A comfortable second bedroom with natural light, tiled flooring, and a functional layout.",
        note: "Note: The furniture shown in the bedroom photographs is for presentation only and is not included with the rental.",
        cap1: "Primary Bedroom",
        cap2: "Second Bedroom"
      },
      view: {
        label: "VIEW FROM THE PRIMARY BEDROOM",
        title: "Wake Up to a Beautiful Lake and Greenery View",
        desc: "Enjoy a relaxing view from the primary bedroom overlooking mature palm trees, open green space, and the community lake."
      },
      f6: {
        title: "Bathrooms",
        desc: "The bathrooms feature tiled bathing areas, storage vanities, and clean neutral finishes.",
        cap1: "Full Bathroom",
        cap2: "Second Full Bathroom",
        cap3: "Convenient First-Floor Half Bath"
      },
      f7: {
        title: "A Practical Two-Story Layout",
        desc: "The first floor provides the main living area, kitchen, half bathroom, and patio access. The bedrooms and full bathrooms are upstairs, creating separation between shared and private spaces."
      }
    },
    communityFeatures: {
      title: "Community Features and Everyday Convenience",
      items: [
        { title: "Community Pool", desc: "Enjoy access to the community swimming pool and managed recreational areas.", icon: "Sun" },
        { title: "Overnight Security Guard", desc: "The community provides an overnight security guard.", icon: "Shield" },
        { title: "Two Assigned Parking Spaces", desc: "The townhouse includes two private assigned parking spaces.", icon: "Car" },
        { title: "Internet Included", desc: "Internet service is included in the monthly rent.", icon: "Wifi" },
        { title: "In-Unit Washer and Dryer", desc: "Enjoy the convenience of a washer and dryer located inside the townhouse.", icon: "CheckSquare" },
        { title: "Private Covered Patio", desc: "A private, covered, and fenced patio provides additional space for relaxing or entertaining.", icon: "Umbrella" },
        { title: "No Rear Neighbors", desc: "There are no neighbors directly behind the townhouse, providing additional rear privacy.", icon: "EyeOff" },
        { title: "Lake and Greenery View", desc: "The primary bedroom overlooks mature palm trees, open green space, and the community lake.", icon: "Image" },
        { title: "Residential Community", desc: "The HOA rules preserve the community’s residential character and prohibit commercial activity inside the residences.", icon: "Home" },
        { title: "Community Quiet Standards", desc: "Community noise standards support a more peaceful residential environment, particularly between 11:00 p.m. and 8:00 a.m.", icon: "Moon" },
        { title: "Managed Common Areas", desc: "The HOA maintains standards requiring common areas to remain clean, orderly, and unobstructed.", icon: "CheckCircle" },
        { title: "No Unauthorized Soliciting", desc: "Unauthorized door-to-door solicitation is prohibited within the community.", icon: "XCircle" }
      ]
    },
    applicationProcess: {
      title: "Rental Requirements and HOA Approval",
      intro: "Tuscan Lake Villas requires prospective tenants to complete an HOA screening and approval process. The process begins after the property owner has selected a qualified applicant. The HOA application is separate from the initial tour-request form on this website.",
      accordionTitle: "HOA Application Process for Selected Applicants",
      shortIntro: "Selected applicants must complete the community’s standard screening and approval process before moving in.",
      steps: [
        { title: "Submit an Initial Rental Inquiry", desc: "Complete the website form to request information or schedule a private tour. This initial form is not the official HOA application." },
        { title: "Property Owner Review", desc: "The property owner reviews the prospective renter’s information and discusses the lease terms and property requirements." },
        { title: "Written One-Year Lease", desc: "The HOA requires a written lease with a minimum term of one year. The lease must require compliance with the HOA Declaration, Articles of Incorporation, Bylaws, and Rules and Regulations." },
        { title: "Complete the HOA Application", desc: "After being selected by the owner, each applicant must complete the current rental application provided by the HOA or property management." },
        { title: "Pay the HOA Application Fee", desc: "The governing documents identify a $75 HOA application fee for tenant screening and approval. The applicant should confirm the current fee and payment instructions with property management." },
        { title: "Credit and Background Screening", desc: "The HOA screening includes a credit search and a background review, including a police-record search." },
        { title: "HOA Review and Approval", desc: "The HOA reviews the completed application and screening results. Applicants must receive the required HOA approval before moving into the property." },
        { title: "Complete Move-In Arrangements", desc: "After approval, the renter receives final move-in instructions, community rules, parking information, and available access details." }
      ],
      summaryCard: {
        title: "What Applicants Should Expect",
        items: [
          "Minimum one-year written lease",
          "Separate HOA rental application",
          "$75 HOA application fee, subject to current confirmation",
          "Credit screening",
          "Background and police-record screening",
          "Compliance with all HOA governing documents",
          "HOA approval before move-in"
        ],
        disclosure: "HOA requirements, fees, forms, screening procedures, and processing times are subject to the association’s current policies. The property owner will provide the current application instructions to selected applicants."
      },
      cta: {
        title: "Ready to See the Townhouse?",
        desc: "Start by requesting a private tour. We will explain the rental and HOA application process and answer your questions.",
        btn: "Request a Private Tour"
      }
    },
    amenities: {
      title: "Community Comforts Included",
      subtitle: "Enjoy access to the community pool, overnight security, two assigned private parking spaces, and internet included in the monthly rent.",
      list: [
        "Community Pool",
        "Overnight Security Guard",
        "Two Private Assigned Parking Spaces",
        "Internet Included",
        "Washer and dryer inside the townhouse",
        "No Rear Neighbors",
        "Greenery, Trees, Railroad, and Lake Nearby"
      ]
    },
    gallery: {
      title: "Photo Gallery",
      subtitle: "Explore the spaces of your potential new home.",
      of: "of",
      alts: [
        "Front exterior of the two-story townhouse showing two private assigned parking spaces directly in front.",
        "Updated white kitchen with stainless-steel appliances",
        "Comfortable living area looking towards patio",
        "Bright living area with stone accent wall",
        "Private covered patio seating area",
        "Private covered and fenced patio",
        "Covered private patio with a built-in outdoor sink, counter, and preparation area.",
        "Primary Bedroom",
        "View from the primary bedroom overlooking palm trees, green space, and a community lake.",
        "Second Bedroom",
        "Full Bathroom",
        "Second Full Bathroom",
        "Convenient First-Floor Half Bath",
        "First floor view showing stairs and front entrance layout"
      ],
      captions: {
        frontExterior: "Front Exterior and Two Private Assigned Parking Spaces",
        lakeView: "Lake and Greenery View From the Primary Bedroom"
      }
    },
    pricing: {
      badge: "Available for Rent",
      price: "$2,800",
      period: "/ month",
      desc: "A premium living experience with essential amenities included.",
      call: "Call 786-529-1915",
      text: "Send a Text",
      included: "What's Included",
      items: [
        "Internet included",
        "In-unit washer and dryer",
        "Two assigned private parking spaces",
        "Community pool access",
        "Overnight community security"
      ],
      btn: "Request a Tour"
    },
    contact: {
      title: "Interested in This Townhouse?",
      subtitle: "Fill out the form below to request a tour or ask questions.",
      hoaNotice: "This form is for rental inquiries and tour requests. It is not the official HOA application. Selected applicants will receive separate HOA application instructions.",
      successTitle: "Thank you.",
      successTitleUpdate: "Thank you. We received your request and will contact you shortly.",
      successDesc: "Your inquiry has been received. A confirmation text message has been sent to the phone number provided. We will contact you soon to discuss the townhouse and schedule a tour.",
      successBtn: "Send another message",
      name: "Full Name *",
      phone: "Mobile Number *",
      email: "Email Address",
      date: "Desired Move-In Date",
      occ: "Number of Occupants",
      tour: "Preferred Tour Date and Time",
      msg: "Message",
      consent: "I agree to be contacted about this rental inquiry by phone, text message, or email. *",
      btn: "Request a Private Tour",
      btnCheck: "Check Availability and Request a Tour",
      btnSending: "Sending your inquiry...",
      submitError: "We could not send your inquiry. Please try again or call or text 786-529-1915.",
      note: "We will never request sensitive information like Social Security numbers, identification documents, bank information, or application payments through this form.",
      langField: "Preferred Language",
      langValue: "English",
      errName: "Name is required",
      errPhone: "Phone number is required",
      errPhoneInvalid: "Please enter a valid 10-digit US phone number",
      errEmail1: "Email is required",
      errEmail2: "Email is invalid",
      errConsent: "You must agree to be contacted",
      phName: "John Doe",
      phDate: "e.g., Next Tuesday afternoon",
      phMsg: "Any specific questions?",
      select: "Select...",
      addMoreDetails: "Add More Details"
    },
    cta: {
      title: "Could This Be Your Next Home?",
      desc: "Schedule a private tour and see everything this townhouse has to offer.",
      btn: "Request a Tour",
      call: "Call",
      text: "Text",
      directions: "Get Directions",
      directionsAria: "Get directions to 7429 NW 182nd St, Hialeah, Florida"
    },
    footer: {
      title: "Townhouse for Rent",
      price: "$2,800 per month",
      contact: "Contact",
      callText: "Call or text",
      disclaimer: "This property is offered in accordance with applicable federal, state, and local fair housing laws.",
      rights: "Property Owner. All rights reserved."
    },
    mobileBar: {
      call: "Call",
      text: "Text",
      tour: "Tour",
      directions: "Directions",
      directionsAria: "Get directions to 7429 NW 182nd St, Hialeah, Florida"
    }
  },
  es: {
    nav: {
      home: "Inicio",
      features: "Características",
      gallery: "Galería",
      amenities: "Comodidades",
      contact: "Contacto",
      schedule: "Programe una visita"
    },
    hero: {
      badge: "En Alquiler",
      title: "Hermoso Townhouse de Dos Pisos",
      price: "$2,800 mensuales",
      internet: "Internet incluido",
      parking: "Dos espacios de estacionamiento asignados",
      pool: "Piscina comunitaria",
      tour: "Programe una visita",
      call: "Llamar",
      text: "Enviar mensaje",
      directions: "Cómo llegar",
      directionsAria: "Obtener indicaciones para llegar a 7429 NW 182nd St, Hialeah, Florida",
      address: "7429 NW 182nd St, Hialeah, FL 33015",
      available: "Disponible Ahora",
      bedBath: "2 Habitaciones • 2.5 Baños",
      internetInc: "Internet Incluido",
      parkingInc: "Dos Estacionamientos Asignados",
      poolInc: "Piscina Comunitaria",
      laundryInc: "Lavadora y Secadora",
      checkAvail: "Verificar Disponibilidad",
      callNow: "Llamar Ahora",
      sendText: "Enviar Mensaje"
    },
    quickFacts: {
      bed: "2 Habitaciones",
      bath: "2.5 Baños",
      laundry: "Lavadora y secadora dentro de la propiedad",
      rent: "$2,800 Mensuales",
      internet: "Internet incluido",
      parking: "Dos espacios de estacionamiento asignados",
      pool: "Piscina comunitaria",
      security: "Seguridad durante la noche"
    },
    exterior: {
      label: "BIENVENIDO A SU PRÓXIMO HOGAR",
      title: "Acogedora Fachada con Dos Estacionamientos Privados",
      desc: "Disfrute de un luminoso townhouse de dos pisos rodeado de palmeras y con una acogedora entrada cubierta. La propiedad incluye dos espacios privados de estacionamiento asignados, convenientemente ubicados justo al frente para facilitar el acceso diario. Su fachada de inspiración mediterránea, techo de tejas y agradable entorno comunitario crean una excelente primera impresión.",
      badges: [
        "Dos Estacionamientos Privados Asignados",
        "Estacionamiento Justo al Frente",
        "Entrada Cubierta",
        "Townhouse de Dos Pisos"
      ],
      btn: "Programar una Visita Privada"
    },
    intro: {
      title: "Un hogar cómodo con espacio, privacidad y conveniencia",
      p1: "Disfrute de una luminosa distribución de dos pisos, una cocina renovada, cómodas áreas de estar, lavadora y secadora dentro de la propiedad, un patio privado y cubierto, dos espacios de estacionamiento asignados y excelentes comodidades comunitarias.",
      p2: "El servicio de internet está incluido en la renta mensual.",
      btn: "Programe su visita privada"
    },
    features: {
      title: "Características de la propiedad",
      subtitle: "Espacios cuidadosamente diseñados para una vida cómoda.",
      f1: {
        title: "Sala amplia y acogedora",
        desc: "La sala principal cuenta con pisos claros, molduras de techo, una distintiva pared decorativa de piedra con iluminación incorporada y un cómodo diseño abierto."
      },
      f2: {
        title: "Cocina renovada",
        desc: "La cocina cuenta con gabinetes estilo shaker blancos, electrodomésticos de acero inoxidable, encimeras modernas, una gran península y una conexión abierta con la sala principal."
      },
      f3: {
        title: "Lavadora y secadora dentro de la propiedad",
        desc: "Electrodomésticos grandes de primera calidad para su conveniencia."
      },
      f4: {
        title: "Su propio espacio privado al aire libre",
        desc: "Disfrute de un patio privado y cubierto, cercado, con espacio para sentarse al aire libre, cenar, relajarse o entretenerse. Sin vecinos directamente en la parte trasera. Más allá de la comunidad hay áreas verdes, árboles maduros, una vía férrea y un lago.",
        sinkHeading: "Fregadero exterior y área de preparación",
        sinkDesc: "El patio privado y techado incluye un fregadero empotrado y una encimera, ofreciendo un espacio práctico para preparar alimentos, limpiar y disfrutar reuniones al aire libre."
      },
      f5: {
        title: "Habitaciones",
        p1: "Una habitación principal luminosa con techos altos, luz natural, pisos de cerámica y espacio flexible.",
        p2: "Una cómoda segunda habitación con luz natural, pisos de cerámica y una distribución funcional.",
        note: "Nota: Los muebles que se muestran en las fotografías de las habitaciones son solo para presentación y no están incluidos en el alquiler.",
        cap1: "Habitación principal",
        cap2: "Segunda habitación"
      },
      view: {
        label: "VISTA DESDE LA HABITACIÓN PRINCIPAL",
        title: "Disfrute de una hermosa vista al lago y a las áreas verdes",
        desc: "Disfrute de una relajante vista desde la habitación principal hacia las palmeras, las áreas verdes y el lago de la comunidad."
      },
      f6: {
        title: "Baños",
        desc: "Los baños cuentan con áreas de ducha con azulejos, tocadores de almacenamiento y acabados limpios y neutrales.",
        cap1: "Baño completo",
        cap2: "Segundo baño completo",
        cap3: "Cómodo medio baño en el primer piso"
      },
      f7: {
        title: "Una distribución práctica de dos pisos",
        desc: "El primer piso ofrece la sala principal, la cocina, un medio baño y acceso al patio. Las habitaciones y los baños completos están en el piso superior, creando separación entre las áreas compartidas y privadas."
      }
    },
    communityFeatures: {
      title: "Comodidades de la Comunidad y Conveniencia Diaria",
      items: [
        { title: "Piscina Comunitaria", desc: "Disfrute del acceso a la piscina comunitaria y a las áreas recreativas administradas por la asociación.", icon: "Sun" },
        { title: "Guardia de Seguridad Durante la Noche", desc: "La comunidad cuenta con un guardia de seguridad durante la noche.", icon: "Shield" },
        { title: "Dos Espacios de Estacionamiento Asignados", desc: "El townhouse incluye dos espacios privados de estacionamiento asignados.", icon: "Car" },
        { title: "Internet Incluido", desc: "El servicio de internet está incluido en la renta mensual.", icon: "Wifi" },
        { title: "Lavadora y Secadora Dentro de la Propiedad", desc: "Disfrute de la comodidad de tener lavadora y secadora dentro del townhouse.", icon: "CheckSquare" },
        { title: "Patio Privado y Cubierto", desc: "Un patio privado, cubierto y cercado ofrece espacio adicional para relajarse o compartir.", icon: "Umbrella" },
        { title: "Sin Vecinos Directamente en la Parte Trasera", desc: "No hay vecinos directamente detrás del townhouse, lo que brinda mayor privacidad en la parte trasera.", icon: "EyeOff" },
        { title: "Vista al Lago y a las Áreas Verdes", desc: "La habitación principal ofrece una vista hacia las palmeras, las áreas verdes y el lago de la comunidad.", icon: "Image" },
        { title: "Comunidad Residencial", desc: "Las reglas de la asociación ayudan a conservar el carácter residencial de la comunidad y no permiten actividades comerciales dentro de las viviendas.", icon: "Home" },
        { title: "Normas Comunitarias de Ruido", desc: "Las normas comunitarias sobre el ruido ayudan a mantener un ambiente residencial más tranquilo, especialmente entre las 11:00 p. m. y las 8:00 a. m.", icon: "Moon" },
        { title: "Áreas Comunes Administradas", desc: "La asociación mantiene normas para que las áreas comunes permanezcan limpias, ordenadas y sin obstrucciones.", icon: "CheckCircle" },
        { title: "Sin Solicitudes No Autorizadas", desc: "No se permiten solicitudes de puerta en puerta sin autorización dentro de la comunidad.", icon: "XCircle" }
      ]
    },
    applicationProcess: {
      title: "Requisitos de Alquiler y Aprobación de la Asociación",
      intro: "Tuscan Lake Villas requiere que los posibles inquilinos completen un proceso de evaluación y aprobación de la asociación. El proceso comienza después de que el propietario haya seleccionado a un solicitante calificado. La solicitud de la asociación es independiente del formulario para solicitar una visita disponible en este sitio web.",
      accordionTitle: "Proceso de Solicitud de la Asociación para Solicitantes Seleccionados",
      shortIntro: "Los solicitantes seleccionados deberán completar el proceso estándar de evaluación y aprobación de la comunidad antes de mudarse.",
      steps: [
        { title: "Envíe una Solicitud Inicial", desc: "Complete el formulario del sitio web para solicitar información o programar una visita privada. Este formulario inicial no es la solicitud oficial de la asociación." },
        { title: "Revisión por Parte del Propietario", desc: "El propietario revisa la información del posible inquilino y conversa sobre los términos del contrato y los requisitos de la propiedad." },
        { title: "Contrato Escrito de un Año", desc: "La asociación requiere un contrato de arrendamiento por escrito con un plazo mínimo de un año. El contrato debe exigir el cumplimiento de la Declaración, los Artículos de Incorporación, los Estatutos y las Reglas y Regulaciones de la asociación." },
        { title: "Complete la Solicitud de la Asociación", desc: "Después de ser seleccionado por el propietario, cada solicitante deberá completar la solicitud de alquiler vigente proporcionada por la asociación o la administración de la propiedad." },
        { title: "Pague la Tarifa de Solicitud", desc: "Los documentos de la asociación indican una tarifa de solicitud de $75 para la evaluación y aprobación del inquilino. El solicitante deberá confirmar con la administración el monto vigente y las instrucciones de pago." },
        { title: "Evaluación de Crédito y Antecedentes", desc: "La evaluación de la asociación incluye una verificación de crédito y una revisión de antecedentes, incluyendo una búsqueda de registros policiales." },
        { title: "Revisión y Aprobación de la Asociación", desc: "La asociación revisa la solicitud completa y los resultados de la evaluación. Los solicitantes deben recibir la aprobación requerida antes de mudarse a la propiedad." },
        { title: "Complete los Preparativos para la Mudanza", desc: "Después de la aprobación, el inquilino recibirá las instrucciones finales para la mudanza, las reglas de la comunidad, la información de estacionamiento y los detalles de acceso disponibles." }
      ],
      summaryCard: {
        title: "Qué Deben Esperar los Solicitantes",
        items: [
          "Contrato escrito por un mínimo de un año",
          "Solicitud de alquiler separada de la asociación",
          "Tarifa de solicitud de $75, sujeta a confirmación vigente",
          "Verificación de crédito",
          "Revisión de antecedentes y registros policiales",
          "Cumplimiento de todos los documentos de la asociación",
          "Aprobación de la asociación antes de la mudanza"
        ],
        disclosure: "Los requisitos, tarifas, formularios, procedimientos de evaluación y tiempos de procesamiento están sujetos a las políticas vigentes de la asociación. El propietario proporcionará las instrucciones actuales a los solicitantes seleccionados."
      },
      cta: {
        title: "¿Le Gustaría Conocer el Townhouse?",
        desc: "Comience solicitando una visita privada. Le explicaremos el proceso de alquiler y la solicitud de la asociación y responderemos sus preguntas.",
        btn: "Solicitar una Visita Privada"
      }
    },
    amenities: {
      title: "Comodidades de la comunidad incluidas",
      subtitle: "Disfrute de acceso a la piscina comunitaria, seguridad durante la noche, dos espacios de estacionamiento privados asignados e internet incluido en la renta mensual.",
      list: [
        "Piscina comunitaria",
        "Seguridad durante la noche",
        "Dos espacios de estacionamiento asignados",
        "Internet incluido",
        "Lavadora y secadora dentro de la propiedad",
        "Sin vecinos directamente en la parte trasera",
        "Áreas verdes, árboles, vía férrea y lago cercanos"
      ]
    },
    gallery: {
      title: "Galería de fotos",
      subtitle: "Explore los espacios de su futuro hogar.",
      of: "de",
      alts: [
        "Fachada principal del townhouse de dos pisos con dos espacios privados de estacionamiento asignados justo al frente.",
        "Cocina renovada blanca con electrodomésticos de acero inoxidable",
        "Sala de estar cómoda mirando hacia el patio",
        "Sala amplia y acogedora con pared decorativa de piedra",
        "Área de descanso en patio cubierto privado",
        "Patio privado y cubierto",
        "Patio privado y techado con fregadero exterior, encimera y área de preparación.",
        "Habitación principal",
        "Vista desde la habitación principal hacia las palmeras, las áreas verdes y el lago de la comunidad.",
        "Segunda habitación",
        "Baño completo",
        "Segundo baño completo",
        "Cómodo medio baño en el primer piso",
        "Vista del primer piso mostrando las escaleras y la entrada principal"
      ],
      captions: {
        frontExterior: "Fachada Principal y Dos Estacionamientos Privados Asignados",
        lakeView: "Vista desde la habitación principal hacia las palmeras, las áreas verdes y el lago de la comunidad."
      }
    },
    pricing: {
      badge: "Disponible para alquilar",
      price: "$2,800",
      period: "mensuales",
      desc: "Una experiencia de vida premium con comodidades esenciales incluidas.",
      call: "Llamar al 786-529-1915",
      text: "Enviar un mensaje",
      included: "Qué incluye",
      items: [
        "Internet incluido",
        "Lavadora y secadora dentro de la propiedad",
        "Dos espacios de estacionamiento asignados",
        "Acceso a piscina comunitaria",
        "Seguridad comunitaria durante la noche"
      ],
      btn: "Solicitar una visita"
    },
    contact: {
      title: "¿Le interesa este townhouse?",
      subtitle: "Complete el formulario a continuación para solicitar una visita o hacer preguntas.",
      hoaNotice: "Este formulario es para solicitar información y coordinar visitas. No es la solicitud oficial de la asociación. Los solicitantes seleccionados recibirán instrucciones separadas para completar la solicitud de la asociación.",
      successTitle: "Gracias.",
      successTitleUpdate: "Gracias. Recibimos tu solicitud y nos comunicaremos contigo pronto.",
      successDesc: "Hemos recibido su solicitud. Se envió un mensaje de confirmación al número de teléfono proporcionado. Nos comunicaremos con usted pronto para conversar sobre el townhouse y coordinar una visita.",
      successBtn: "Enviar otro mensaje",
      name: "Nombre completo *",
      phone: "Número móvil *",
      email: "Correo electrónico",
      date: "Fecha deseada para mudarse",
      occ: "Número de ocupantes",
      tour: "Fecha y hora preferidas para la visita",
      msg: "Mensaje",
      consent: "Acepto que se comuniquen conmigo por teléfono, mensaje de texto o correo electrónico en relación con esta propiedad en alquiler. *",
      btn: "Solicitar una visita privada",
      btnCheck: "Verificar Disponibilidad y Solicitar una Visita",
      btnSending: "Enviando su solicitud...",
      submitError: "No pudimos enviar su solicitud. Inténtelo nuevamente o llame o envíe un mensaje al 786-529-1915.",
      note: "Nunca solicitaremos información confidencial como números de Seguro Social, documentos de identificación, información bancaria o pagos de solicitud a través de este formulario.",
      langField: "Idioma Preferido",
      langValue: "Español",
      errName: "El nombre es obligatorio",
      errPhone: "El número de teléfono es obligatorio",
      errPhoneInvalid: "Ingrese un número de teléfono válido de 10 dígitos",
      errEmail1: "El correo electrónico es obligatorio",
      errEmail2: "El correo electrónico no es válido",
      errConsent: "Debe aceptar que nos comuniquemos con usted",
      phName: "Juan Pérez",
      phDate: "ej. El próximo martes por la tarde",
      phMsg: "¿Alguna pregunta específica?",
      select: "Seleccione...",
      addMoreDetails: "Agregar más detalles"
    },
    cta: {
      title: "¿Podría ser este su próximo hogar?",
      desc: "Programe una visita privada y conozca todo lo que este townhouse tiene para ofrecer.",
      btn: "Solicitar una visita",
      call: "Llamar",
      text: "Enviar mensaje",
      directions: "Cómo llegar",
      directionsAria: "Obtener indicaciones para llegar a 7429 NW 182nd St, Hialeah, Florida"
    },
    footer: {
      title: "Townhouse en Alquiler",
      price: "$2,800 mensuales",
      contact: "Contacto",
      callText: "Llame o envíe un mensaje",
      disclaimer: "Esta propiedad se ofrece de acuerdo con las leyes federales, estatales y locales de vivienda justa vigentes.",
      rights: "Propietario de la vivienda. Todos los derechos reservados."
    },
    mobileBar: {
      call: "Llamar",
      text: "Enviar mensaje",
      tour: "Visita",
      directions: "Cómo llegar",
      directionsAria: "Obtener indicaciones para llegar a 7429 NW 182nd St, Hialeah, Florida"
    }
  }
};